import React, { Component } from "react";
import { Typography, Snackbar, SnackbarContent, Button } from "@material-ui/core";
import { connect } from "react-redux";

import {
    getUserData,
    setPage,
    setRowsPerPage,
    setReportStatus,
    setSelectedRow,
    setReportEditStatus,
    setStatusChangeModal,
    deleteReport,
    setDeleteStatus,
    getTmPlans,
    deleteAllReport
} from "./actions";
import {
    StyledCard,
    StyledContent,
    StyledViewContainer,
    StyledHeader,
} from "../../styles";
import {
    selectReportFilterState,
    selectTableData,
    selectPage,
    selectRowsPerPage,
    selectSelectedRow,
    selectDeleteStatus,
    canUpdate,
    canCreate,
    canDelete,
    getRequestedTmPlans,
} from "./selectors";
import "./submittedReportsStyles.css";
import TableData from "./TableData";
import ChangeStatusModal from "./ChangeStatusModal";
import Box from '@material-ui/core/Box';


class RequestedTMPlans extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modalOpen: false,
            modalType: false,
            modalData: false,
        };
        props.getUserData();
        props.getTmPlans();
    }
    render() {
        const {
            tableData,
            page,
            rowsPerPage,
            setPage,
            setRowsPerPage,
            selectedRow,
            setSelectedRow,
            deletedStatus,
            deleteReport,
            deleteAllReport
        } = this.props;
        let disable = false;
        if(!tableData){ disable = true;}        
        return (
            <div>
                <StyledCard>
                    <StyledHeader>
                    <Box display="flex" >
                        <Box  flexGrow={1} style={{marginTop:"10px"}}>
                        <Typography variant="h5">Requested TM Plans</Typography>
                        </Box>
                        <Box style={{marginTop:"8px"}}>
                        <Button
                            style={{
                                width: "270px",
                                marginLeft: "30px",
                                background: "#0188cc",
                            }}
                            variant="contained"
                            color="primary"
                            disabled={disable}
                            onClick={() => {
                                this.setState({
                                    modalOpen: true,
                                    modalType: "delete-all",
                                    modalData: "delete-all"
                                });
                            }}
                        >
                        <Typography
                            style={{
                                color: "white",
                                fontSize: "13px",
                            }}
                        >
                            Delete All Plans
                        </Typography>
                        </Button>
                        </Box>
                    </Box>
                        
                        
                    </StyledHeader>
                    <StyledContent>
                        <StyledViewContainer>
                            <TableData
                                tableData={tableData}
                                page={page}
                                rowsPerPage={rowsPerPage}
                                setPage={setPage}
                                setRowsPerPage={setRowsPerPage}
                                selectedRow={selectedRow}
                                setSelectedRow={setSelectedRow}
                                setModal={(open, type, index) => {
                                    this.setState({
                                        modalOpen: open,
                                        modalType: type,
                                        modalData: tableData[index],
                                    });
                                }}
                                canDelete={this.props.canDelete}
                                canUpdate={this.props.canUpdate}
                            />
                            <ChangeStatusModal
                                modalOpen={this.state.modalOpen}
                                modalType={this.state.modalType}
                                modalData={this.state.modalData}
                                deleteReport={deleteReport}
                                deleteAllReport={deleteAllReport}
                                setModal={(open, type, index) => {
                                    this.setState({
                                        modalOpen: open,
                                        modalType: type,
                                        modalData: index,
                                    });
                                }}
                            />
                            <Snackbar
                                anchorOrigin={{
                                    vertical: "bottom",
                                    horizontal: "left",
                                }}
                                autoHideDuration={4000}
                                open={
                                    deletedStatus.deleteSuccess ||
                                    deletedStatus.deleteFail
                                }
                                onClose={() => {
                                    setDeleteStatus();
                                }}
                            >
                                <SnackbarContent
                                    style={{
                                        backgroundColor: deletedStatus.deleteSuccess
                                            ? "green"
                                            : deletedStatus.deleteFail
                                            ? "red"
                                            : "white",
                                        color: "white",
                                    }}
                                    message={
                                        deletedStatus.deleteSuccess
                                            ? "Report Successfully Deleted"
                                            : "Unable to Delete Report, Please Contact System Admin With Report Details"
                                    }
                                />
                            </Snackbar>
                        </StyledViewContainer>
                    </StyledContent>
                </StyledCard>
            </div>
        );
    }
}
export default connect(
    (store) => {
        return {
            filterState: selectReportFilterState(store),
            tableData: selectTableData(store),
            page: selectPage(store),
            rowsPerPage: selectRowsPerPage(store),
            selectedRow: selectSelectedRow(store),

            deletedStatus: selectDeleteStatus(store),
            canUpdate: canUpdate(store),
            canCreate: canCreate(store),
            canDelete: canDelete(store),
            tmplan: getRequestedTmPlans(store),
        };
    },
    {
        getUserData,
        setPage,
        setRowsPerPage,
        setReportStatus,
        setSelectedRow,
        setReportEditStatus,
        setStatusChangeModal,
        deleteReport,
        deleteAllReport,
        setDeleteStatus,
        getTmPlans,
    }
)(RequestedTMPlans);
